module.exports = __webpack_public_path__ + "static/gg_color-ba69c19d0255f748a4ae24093f756f65.jpg";